/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  /**
   * Weight to render the SVG in. Defaults to "normal"
   */
  weight?: "thin" | "normal";
}
export const IconWarningSolid = ({
  fill = "none",
  stroke = "currentColor",
  weight = "normal",
  ...props
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    css={css`
      * {
        vector-effect: non-scaling-stroke;
      }
      overflow: visible;
      height: 24px;
    `}
    {...props}
  >
    <path
      fill="currentColor"
      d="M23.119 20 13.772 2.15a2 2 0 0 0-3.543 0L.881 20a2 2 0 0 0 1.772 2.928h18.694A2 2 0 0 0 23.119 20M11 8.423a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0zm1.05 11.51h-.028a1.53 1.53 0 0 1-1.522-1.47 1.475 1.475 0 0 1 1.421-1.529l.027-.001h.028A1.527 1.527 0 0 1 13.5 18.4c.032.814-.602 1.5-1.416 1.532z"
    />
  </svg>
);
